'use strict';
angular.module('roleManageModule', [
    'manageCfg.roleManageMent.permissionAssignment.serviceModule',
    'manageCfg.roleManageMent.editorcreateRole',
    'manageCfg.roleManageMent.permissionAssignment',
    'manageCfg.roleManageMent.userManageMentaddUser',
    'manageCfg.roleManageMent.newRoteModule',
    'trsLimitToModule',
    'trsPermissionAssignmentDirectve',
])
    .controller('roleManageMentCtrl', ['$scope', '$element', '$timeout', 'localStorageService', '$q', '$modal', '$compile', '$state', '$stateParams', 'trsHttpService', 'trsGroupTreeLocationService', 'modalDialog', 'permissionService', '$http', '$templateCache', 'globleParamsSet', '$sessionStorage', 'editingCenterService', function($scope, $element, $timeout, localStorageService, $q, $modal, $compile, $state, $stateParams, trsHttpService, trsGroupTreeLocationService, modalDialog, permissionService, $http, $templateCache, globleParamsSet, $sessionStorage, editingCenterService) {
        initStatus();
        $scope.showToggle = function(node) {
            if (node.HASCHILDREN == 'true' && node.CHILDREN.length === 0) {
                var paramsT = {
                    'serviceid': 'mlf_group',
                    'methodname': 'queryChildGroupsWithSecondRight', // "queryChildGroupsForGroupUserMgr",
                    'GroupId': node.GROUPID,
                };
                trsHttpService.httpServer('/wcm/mlfcenter.do', paramsT, 'get').then(function(dataC) {
                    node.CHILDREN = dataC.CHILDREN;
                    ExpandedEmptyNodes(node);
                });
            }
        };
        // 点击树回调函数开始
        $scope.showSelected = function(node) {
            $stateParams.groupid = node.GROUPID;
            $scope.status.createUserStatus = false; // 将新增角色按钮状态设置为否，默认为非编辑状态
            $scope.status.isSystemRole = false;
            $scope.status.operatingAuthority = {};
            delete $scope.status.tab;
            delete $scope.selectRoleObj; // 清除选中的角色
            // 清楚按钮选中状态
            getGroupData(node);
            getOperatingAuthority(node).then(function(data) {
                for (var i in data) {
                    if (i === 'add') {
                        $scope.status.operatingAuthority[i] = data[i];
                    }
                }
            });
        };

        /**
         * [initTreeData description] 初始化导航树数据开始
         * @return  {[type]}  [return description]
         */
        function initTreeData() {
            var deffer = $q.defer();
            var params = {
                'serviceid': 'mlf_group',
                'methodname': 'queryGroupTreeWithSecondRight', // "queryGroupTreeWithMyPath",
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.dataForTheTree = [data];
                // 默认展开树操作开始
                ExpandedNodes();
                // 默认展开树操作结束
                deffer.resolve();
            });
            return deffer.promise;
        }

        // 监控更改分组成功开始
        $scope.$on('changeGroup', function(event, data) {
            routingMemory(data.GROUPID);
        });
        // 监控更改分组成功结束
        // 监控保存角色开始
        $scope.$on('saveRole', function(event, data) {
            for (var i = 0; i < $scope.roleDatas.length; i++) {
                if (data.ROLEID === $scope.roleDatas[i].ROLEID) {
                    $scope.roleDatas[i] = data;
                }
            }
            $scope.roleData = data;
        });
        // 监控保存角色结束
        // 调用获取组织树的服务结束
        // 创建角色按钮开始
        $scope.createRole = function() {
            if (angular.isUndefined($scope.groupObj)) {
                modalDialog.alertType('请选择组织', '请选择组织', 'warning', false);
                return;
            }
            var modalInstance = $modal.open({
                templateUrl: './manageConfig/roleManageMent/addRole/addRole_tpl.html',
                scope: $scope,
                windowClass: 'addRole',
                backdrop: false,
                controller: 'addRoleModuleCtrl',
            });
            modalInstance.result.then(function() {
                $scope.showSelected($scope.selectedNode);
            });
        };
        // 创建角色按钮结束
        // 选择角色功能开始
        $scope.selectRole = function(roleData) {
            $scope.roleData = roleData;
            $scope.$broadcast('roleData', roleData);
            if (roleData.ROLEID === '1' || roleData.ROLEID === '2') {
                $scope.status.operatingAuthority = {};
                $scope.status.isShowGroupTree = false;
                delete $scope.roleDatas;
                delete $scope.groupObj;
                delete $scope.selectedNode;
                selectDefaultButton();
                return;
            }
            getRealGroupObj(roleData.ROLEID).then(function(data) {
                $scope.realGroupObj = data;
                getOperatingAuthority(data).then(function(data) {
                    for (var i in data) {
                        if (i !== 'add') {
                            $scope.status.operatingAuthority[i] = data[i];
                        }
                    }
                    if (roleData.ISTENANTADMIN === 'true') { // 如果发现该角色是租户管理员，要先去掉角色编辑 功能权限分配 模块可见性 功能
                        delete $scope.status.operatingAuthority.edit;
                        delete $scope.status.operatingAuthority.setright;
                    }
                    selectDefaultButton();
                });
            });
        };

        /**
         * [selectDefaultButton description] 选中角色后，根据权限默认展示按钮页面
         * @return {[type]} [description]
         */
        function selectDefaultButton() {
            $timeout(function() {
                $element.find('.tabWrap li a')[0].click();
            });
        }

        // 选择角色功能结束
        // 主页面头部切换开始
        $scope.selectModule = function(obj) {
            $(obj.target).addClass('manage-head-tabSelected').siblings().removeClass('manage-head-tabSelected');
        };
        // 主页面头部切换结束
        // 编辑角色按钮开始
        $scope.editRole = function() {
            if ($scope.roleData === undefined || $scope.roleData === null) {
                modalDialog.alertType('请先选择角色', '', 'warning', false);
            } else {
                $scope.status.tab = 'roleEdit';
                $state.go('manageconfig.rolemanage.editorcreaterole', {
                    'type': 'edit',
                });
            }
        };
        // 编辑角色按钮结束
        // 添加用户按钮开始
        $scope.addUser = function() {
            if ($scope.roleData === undefined || $scope.roleData === null) {
                modalDialog.alertType('请先选择角色', '', 'warning', false);
            } else {
                $scope.status.noRole = false;
                $scope.status.tab = 'userManager';
                $state.go('manageconfig.rolemanage.adduser');
            }
        };
        // 添加用户按钮结束
        // 权限分配按钮开始
        $scope.rightAssign = function() {
            if ($scope.roleData === undefined || $scope.roleData === null) {
                modalDialog.alertType('请先选择角色', '', 'warning', false);
            } else {
                $scope.status.tab = 'setRight';
                $state.go('manageconfig.rolemanage.permissionassignment');
            }
        };

        /**
         * [showGroupTree queryMlfModule] 点击显示或隐藏组织树
         * @return {[type]} [description] null
         */
        $scope.showGroupTree = function() {
            $scope.status.isShowGroupTree = $scope.status.isShowGroupTree !== true;
            // delete $scope.roleData;
        };

        /**
         * [moduleVisibility queryMlfModule] 模块可见性
         * @return {[type]} [description] null
         */
        $scope.moduleVisibility = function() {
            if ($scope.roleData === undefined || $scope.roleData === null) {
                modalDialog.alertType('请先选择角色', '', 'warning', false);
            } else {
                $scope.status.tab = 'moduleVisibility';
                $state.go('manageconfig.rolemanage.modulevisibility');
            }
        };

        /**
         * [limitInput description]
         * @return  {[type]}  [return description]
         */
        // $scope.limitInput = function() {
        //     if (angular.isDefined($scope.roleSearch)) {
        //         $scope.roleSearch = $scope.roleSearch.length > 16 ? $scope.roleSearch.substr(0, 16) : $scope.roleSearch;
        //     }
        // };
        // 删除角色
        $scope.deleteRole = function(roleID, roleDesc) {

            /* 截取字符串*/
            if (roleDesc.length >= 18) {
                roleDesc = roleDesc.substr(0, 3) + '...';
            }
            if (roleID == 1) {
                modalDialog.alertType('该角色不能被删除', '', 'warning', false);
            } else {
                var DeleteRpleparams = {
                    'serviceid': 'mlf_extrole',
                    'methodname': 'delete',
                    'ObjectIds': roleID,
                };
                modalDialog.confirmModal('您确定要删除该角色？', '您确定要删除该角色？', function() {
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), DeleteRpleparams, 'post')
                        .then(function(data) {
                            $scope.showSelected($scope.selectedNode);
                        });
                });
            }
        };

        /**
         * [ExpandedNodes description] 默认展开树开始
         * @return  {[type]}  [return description]
         */
        function ExpandedNodes() {
            $scope.expandedTest = [];
            $scope.expandedTest.push($scope.dataForTheTree[0]);
        }

        /**
         * [getGroupData description] 默认展开树
         * @param   {[type]}  node  [node description]
         * @return  {[type]}        [return description]
         */
        function getGroupData(node) {
            $timeout(function() {
                $scope.groupObj = node;
                $scope.roleDatas = [];
                $scope.roleData = null;
                var params = {
                    'serviceid': 'mlf_extrole',
                    'methodname': 'query',
                    'GroupId': $scope.groupObj.GROUPID,
                };
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function(data) {
                    $scope.roleDatas = data;
                    if (data.length !== 0) {
                        if (angular.isDefined($scope.status.routeRoleId)) {
                            var flag = false;
                            var selectRole;
                            for (var i in data) {
                                var item = data[i];
                                if (item.ROLEID === $scope.status.routeRoleId) {
                                    selectRole = item;
                                    flag = true;
                                    break;
                                }
                            }
                            if (!flag) {
                                selectRole = data[0];
                            }
                            $scope.selectRole(selectRole);
                            $scope.status.noRole = false;
                            delete $scope.status.routeRoleId;
                        } else {
                            $scope.selectRole(data[0]);
                            $scope.status.noRole = false;
                        }
                    } else {
                        delete $scope.roleData;
                        $scope.status.noRole = true;
                    }
                });
            }, 100);
        }

        /**
         * [ExpandedEmptyNodes description] 无子节点的节点默认展开开始
         * @param   {[type]}  node  [node description]
         * @return  {[type]}        [return description]
         */
        function ExpandedEmptyNodes(node) {
            return;
        }

        /**
         * [initStatus description] 无子节点的节点默认展开结束
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            if ($state.current.name.split('.').length < 3) { // 如果定位在 manageconfig.rolemanage  则重新定向
                // var userInfo = localStorageService.get('mlfCachedUser'); // session改变
                var userInfo = $sessionStorage.get('mlfCachedUser');
                var groupId = userInfo.GroupId;
                $state.go('manageconfig.rolemanage', { groupid: groupId }, { reload: false });
            }
            $scope.status = {
                isSystemUser: false, // 当前登录用户是否是系统管理员
                isSystemRole: false, // 选中角色是否是系统角色
                operatingAuthority: {}, // 对角色的操作权限。
                everyOneRole: {
                    ROLEDESC: 'Everyone',
                    ROLEID: '2',
                    ROLENAME: 'Everyone',
                },
                administratorRole: {
                    ROLEDESC: 'Administrator',
                    ROLEID: '1',
                    ROLENAME: 'Administrator',
                },
                userRole: {
                    ROLEDESC: '用户角色',
                    ROLEID: '3',
                    ROLENAME: '用户角色',
                },
            };
            // 树配置开始
            $scope.treeOptions = Object.assign(editingCenterService.channelTreeOptions(), {
                injectClasses: {
                    ul: 'a1',
                    li: 'a2',
                    liSelected: 'a7',
                    iExpanded: 'a3',
                    iCollapsed: 'a4',
                    iLeaf: 'a5',
                    label: 'a6',
                    labelSelected: 'rolegrouplabselected',
                },
                isLeaf: function(node) {
                    return node.HASCHILDREN === 'false';
                },
                isSelectable: function(node) {
                    return node.HASRIGHT === 'true' && node.PARENTID !== '0';
                },
            });

            // 树配置结束
            isAdministrator().then(function() {
                return isTenantAdministrator();
            }).then(function() {
                return initTreeData();
            }).then(function() {
                $scope.status.routeRoleId = $stateParams.roleid;
                if ($scope.status.isSystemUser) {
                    $scope.selectRole(angular.copy($scope.status.administratorRole));
                } else {
                    routingMemory($stateParams.groupid);
                }
            });
        }

        /**
         * [isAdministrator description] 判断当前用户是否是系统管理员
         * @return  {[type]}  [return description]
         */
        function isAdministrator() {
            var deffer = $q.defer();
            permissionService.isAdministrator().then(function(data) {
                $scope.status.isSystemUser = data;
                deffer.resolve();
            }, function() {
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [isTenantAdministrator description] 是否是租户管理员
         * @return {Boolean} [description]
         */
        function isTenantAdministrator() {
            var deffer = $q.defer();
            permissionService.isTenantAdministrator().then(function(data) {
                $scope.status.isTenantAdministrator = data;
                deffer.resolve();
            }, function() {
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [getOperatingAuthority description] 获取当前用户对指定组织的角色的操作权限
         * @param   {[type]}  group  [group description]
         * @return  {[type]}         [return description]
         */
        function getOperatingAuthority(group) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryGroupOperKey',
                GroupId: group.GROUPID,
                OperType: 'config.role',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                function(data) {
                    deffer.resolve(globleParamsSet.handlePermissionData(data).role);
                });
            return deffer.promise;
        }

        /**
         * [getRealGroupObj description] 精确查询角色所在组织
         * @param   {[type]}  roleId  [roleId description]
         * @return  {[type]}          [return description]
         */
        function getRealGroupObj(roleId) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_extrole',
                methodname: 'getGroupOfRole',
                RoleId: roleId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                .then(function(data) {
                    deffer.resolve(data);
                });
            return deffer.promise;
        }

        /**
         * [routingMemory description] 初始化时的路由记忆功能
         * @param   {[type]}  groupid  [groupid description]
         * @return  {[type]}           [return description]
         */
        function routingMemory(groupid) {
            if (!groupid) {
                $state.go('manageconfig.rolemanage');
                return;
            }
            trsGroupTreeLocationService.getGroupIdsPath(groupid).then(function(idsArray) {
                idsArray.splice(0, 1);
                if (idsArray.length === 0) {
                    $timeout(function() {
                        $scope.selectedNode = $scope.dataForTheTree[0];
                        $scope.showSelected($scope.selectedNode);
                    });
                    return;
                }
                $scope.expandedTest = [];
                trsGroupTreeLocationService.groupTreeLocation(idsArray, $scope.dataForTheTree[0], $scope.selectedNode, $scope.expandedTest, function(tree, array, selectedNode) {
                    delete $scope.dataForTheTree;
                    $scope.status.isShowGroupTree = true;
                    $scope.dataForTheTree = [tree];
                    $scope.expandedTest.push($scope.dataForTheTree[0]);
                    $scope.selectedNode = selectedNode;
                    $scope.showSelected($scope.selectedNode);
                });
            });
        }

        var promise;

        /**
         * [getSuggestions description] 检索建议下拉框
         * @param  {[type]} groupName [description]
         * @return {[type]}           [description]
         */
        $scope.getSuggestions = function(groupName) {
            if (promise) {
                $timeout.cancel(promise);
                promise = null;
            }
            promise = $timeout(function() {
                if (groupName !== '') {
                    var params = {
                        serviceid: 'mlf_extuser',
                        methodname: 'searchGroup',
                        Name: groupName,
                    };
                    if ($scope.status.isRequest) {
                        $scope.status.isRequest = false;
                        return [];
                    } else {
                        return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                            return data;
                        });
                    }
                }
            }, 10);
            return promise;
        };

        /**
         * [description]Suggestion 监控Suggestion
         */
        $scope.$watch('status.searchGroup', function(newValue, oldValue, scope) {
            if (angular.isObject(newValue)) {
                $scope.status.isRequest = true;
                goToGroup(newValue);
            }
        });

        /**
         * [goToGroup description] 跳转到指定组织
         * @param   {[type]}  newValue  [newValue description]
         * @return  {[type]}            [return description]
         */
        function goToGroup(newValue) {
            locationGroupTree(newValue.GROUPIDS, function() {
                $scope.showSelected($scope.selectedNode);
            });
        }

        /**
         * [locationGroupTree description] 定位组织树
         * @param   {[type]}  gropuIds  [gropuIds description]
         * @param   {[type]}  callback  [callback description]
         * @return  {[type]}            [return description]
         */
        function locationGroupTree(gropuIds, callback) {
            $scope.expandedTest = [];
            var groupidsArray = gropuIds.split(',');
            groupidsArray.splice(0, 1);
            if (groupidsArray.length === 0) {
                $timeout(function() {
                    $scope.selectedNode = $scope.dataForTheTree[0];
                    callback();
                });
                return;
            }
            trsGroupTreeLocationService.groupTreeLocation(groupidsArray, $scope.dataForTheTree[0], $scope.selectedNode, $scope.expandedTest, function(tree, array, selectedNode) {
                delete $scope.dataForTheTree;
                $scope.dataForTheTree = [tree];
                $scope.expandedTest.push($scope.dataForTheTree[0]);
                $scope.selectedNode = selectedNode;
                callback();
            });
        }
    }]);
